import SessionsTable from './SessionsTable';

export default SessionsTable;
